import { A11y, Autoplay, default as Swiper, default as SwiperCore, Navigation } from 'swiper';
import 'swiper/css/bundle';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

SwiperCore.use([Navigation, Autoplay, A11y]);

declare let TimelineMax: any;
declare let TweenMax: any;
declare let Linear: any;
@Component({ className: 'js-statement' })
export class StatementComponent {
	private delay = 10000;
	private duration = .3;

	constructor(private element: HTMLElement) {
		const autoplay = this.element.getAttribute('data-statement-autoplay') === "true";

		new Swiper(element, {
			cssMode: false,
			preloadImages: true,
			lazy: true,
			speed: 500,
			spaceBetween: 1,
			slidesPerView: 1,
			centeredSlides: false,
			roundLengths: true,
			watchOverflow: true,
			loop: true,
			direction: 'horizontal',
			watchSlidesProgress: true,
			autoplay: autoplay ? {
				delay: this.delay,
				disableOnInteraction: true,
			} : false,
			initialSlide: 0,
			slideToClickedSlide: false,
			wrapperClass: 'js-statement-wrapper',
			simulateTouch: false,
			preventClicks: true,
			init: true,
			navigation: {
				nextEl: '.js-statement-next',
				prevEl: '.js-statement-prev',
			},
			on: {
				transitionStart: this.setActiveSlideTween,
				afterInit: this.setActiveSlideTween,
			}
		});
	}

	private setActiveSlideTween = (swiper: Swiper) => {
		this.countdown(swiper);
		const reloadBtn = this.element.querySelector('.js-statement-next');
		if (reloadBtn) {
			reloadBtn.classList.remove('spin');
			setTimeout(() => reloadBtn.classList.add('spin'), 1)
		}

	}

	countdown = (swiper: Swiper) => {
		const bar = swiper.slides[swiper.activeIndex].querySelector('.js-statement-countdown') as HTMLElement;
		let id;

		if (swiper.autoplay.running) {
			let count = 100;
			id = setInterval(function () {
				count -= 1
				bar.style.width = count + '%'
				if (count <= 0) {
					clearInterval(id)
				}
			}, this.delay / 100);
		} else {
			clearInterval(id)
			bar.style.width = '0px'
		}
	}
}
